import { ConnectedAccountsLanding } from '@/components/ConnectedAccounts/ConnectedAccountsLanding';
import { useLanguageAwareRouting } from '@/hooks/useLanguageAwareRouting';
import { useRustyState } from '../../state';

export function AccountConnectedAccountsLandingPage() {
  const { api } = useRustyState.getState();
  const { createLanguageURL } = useLanguageAwareRouting();
  const profilePath = createLanguageURL('/account/profile');

  return (
    <ConnectedAccountsLanding
      api={api}
      connectedAccountsHref={`#${profilePath}`}
      onDone={() => {
        window.location.hash = profilePath;
      }}
      onDeleted={async () => {
        if (!(await useRustyState.getState().logout())) {
          window.location.replace(createLanguageURL('/'));
        }
      }}
    />
  );
}
